angular.module('shbdeployer.app').controller('TeamController', [
  '$q',
  '$scope',
  '$state',
  '$transition$',
  'TeamService',
  'UserService',
  'TeamMembershipService',
  'ModalService',
  'Notifications',
  'PaginationService',
  'Authentication',
  function ($q, $scope, $state, $transition$, TeamService, UserService, TeamMembershipService, ModalService, Notifications, PaginationService, Authentication) {
    $scope.state = {
      pagination_count_users: PaginationService.getPaginationLimit('team_available_users'),
      pagination_count_members: PaginationService.getPaginationLimit('team_members'),
    };

    $scope.sortTypeUsers = 'Username';
    $scope.sortReverseUsers = true;
    $scope.users = [];
    $scope.teamMembers = [];
    $scope.leaderCount = 0;

    $scope.orderUsers = function (sortType) {
      $scope.sortReverseUsers = $scope.sortTypeUsers === sortType ? !$scope.sortReverseUsers : false;
      $scope.sortTypeUsers = sortType;
    };

    $scope.changePaginationCountUsers = function () {
      PaginationService.setPaginationLimit('team_available_users', $scope.state.pagination_count_users);
    };

    $scope.sortTypeGroupMembers = 'TeamRole';
    $scope.sortReverseGroupMembers = false;

    $scope.orderGroupMembers = function (sortType) {
      $scope.sortReverseGroupMembers = $scope.sortTypeGroupMembers === sortType ? !$scope.sortReverseGroupMembers : false;
      $scope.sortTypeGroupMembers = sortType;
    };

    $scope.changePaginationCountGroupMembers = function () {
      PaginationService.setPaginationLimit('team_members', $scope.state.pagination_count_members);
    };

    $scope.deleteTeam = function () {
      ModalService.confirmDeletion('Удалить команду? Пользователи из её состава удалены не будут.', function onConfirm(confirmed) {
        if (!confirmed) {
          return;
        }
        deleteTeam();
      });
    };

    $scope.promoteToLeader = function (user) {
      TeamMembershipService.updateMembership(user.MembershipId, user.Id, $scope.team.Id, 1)
        .then(function success() {
          $scope.leaderCount++;
          user.TeamRole = 'Leader';
          Notifications.success('Пользователь назначен руководителем команды', user.Username);
        })
        .catch(function error(err) {
          Notifications.error('Ошибка', err, 'Не удалось обновить роль пользователя');
        });
    };

    $scope.demoteToMember = function (user) {
      TeamMembershipService.updateMembership(user.MembershipId, user.Id, $scope.team.Id, 2)
        .then(function success() {
          user.TeamRole = 'Member';
          $scope.leaderCount--;
          Notifications.success('Пользователь назначен участником команды', user.Username);
        })
        .catch(function error(err) {
          Notifications.error('Ошибка', err, 'Не удалось обновить роль пользователя');
        });
    };

    $scope.addAllUsers = function () {
      var teamMembershipQueries = [];
      angular.forEach($scope.users, function (user) {
        teamMembershipQueries.push(TeamMembershipService.createMembership(user.Id, $scope.team.Id, 2));
      });
      $q.all(teamMembershipQueries)
        .then(function success(data) {
          var users = $scope.users;
          for (var i = 0; i < users.length; i++) {
            var user = users[i];
            user.MembershipId = data[i].Id;
            user.TeamRole = 'Member';
          }
          $scope.teamMembers = $scope.teamMembers.concat(users);
          $scope.users = [];
          Notifications.success('Все пользователи добавлены');
        })
        .catch(function error(err) {
          Notifications.error('Ошибка', err, 'Не удалось обновить состав команды');
        });
    };

    $scope.addUser = function (user) {
      TeamMembershipService.createMembership(user.Id, $scope.team.Id, 2)
        .then(function success(data) {
          removeUserFromArray(user.Id, $scope.users);
          user.TeamRole = 'Member';
          user.MembershipId = data.Id;
          $scope.teamMembers.push(user);
          Notifications.success('Пользователь добавлен в команду', user.Username);
        })
        .catch(function error(err) {
          Notifications.error('Ошибка', err, 'Не удалось обновить состав команды');
        });
    };

    $scope.removeAllUsers = function () {
      var teamMembershipQueries = [];
      angular.forEach($scope.teamMembers, function (user) {
        teamMembershipQueries.push(TeamMembershipService.deleteMembership(user.MembershipId));
      });
      $q.all(teamMembershipQueries)
        .then(function success() {
          $scope.users = $scope.users.concat($scope.teamMembers);
          $scope.teamMembers = [];
          $scope.leaderCount = 0;
          Notifications.success('Все пользователи удалены');
        })
        .catch(function error(err) {
          Notifications.error('Ошибка', err, 'Не удалось обновить состав команды');
        });
    };

    $scope.removeUser = function (user) {
      TeamMembershipService.deleteMembership(user.MembershipId)
        .then(function success() {
          removeUserFromArray(user.Id, $scope.teamMembers);
          if (user.TeamRole === 'Leader') {
            $scope.leaderCount--;
          }
          $scope.users.push(user);
          Notifications.success('Пользователь удален из команды', user.Username);
        })
        .catch(function error(err) {
          Notifications.error('Ошибка', err, 'Не удалось обновить состав команды');
        });
    };

    function deleteTeam() {
      TeamService.deleteTeam($scope.team.Id)
        .then(function success() {
          Notifications.success('Команда удалена', $scope.team.Name);
          $state.go('shbdeployer.teams');
        })
        .catch(function error(err) {
          Notifications.error('Ошибка', err, 'Не удалось удалить команду');
        });
    }

    function removeUserFromArray(id, users) {
      for (var i = 0, l = users.length; i < l; i++) {
        if (users[i].Id === id) {
          users.splice(i, 1);
          return;
        }
      }
    }

    function assignUsersAndMembers(users, memberships) {
      for (var i = 0; i < users.length; i++) {
        var user = users[i];
        var member = false;
        for (var j = 0; j < memberships.length; j++) {
          var membership = memberships[j];
          if (user.Id === membership.UserId) {
            member = true;
            if (membership.Role === 1) {
              user.TeamRole = 'Leader';
              $scope.leaderCount++;
            } else {
              user.TeamRole = 'Member';
            }
            user.MembershipId = membership.Id;
            $scope.teamMembers.push(user);
            break;
          }
        }
        if (!member) {
          $scope.users.push(user);
        }
      }
    }

    function initView() {
      $scope.isAdmin = Authentication.isAdmin();
      $q.all({
        team: TeamService.team($transition$.params().id),
        users: UserService.users(false),
        memberships: TeamService.userMemberships($transition$.params().id),
      })
        .then(function success(data) {
          var users = data.users;
          $scope.team = data.team;
          assignUsersAndMembers(users, data.memberships);
        })
        .catch(function error(err) {
          Notifications.error('Ошибка', err, 'Не удалось получить сведения о команде');
        });
    }

    initView();
  },
]);
